import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { OnBlurValidationDirective } from './directives/on-blur-validation.directive';
import { RgbaToHexPipe } from '@finxone-platform/shared/pipes';
import { HlmDatePickerComponent, HlmDatePickerModule } from '@spartan-ng/ui-date-picker-helm';
import { HlmAutocompleteModule } from '@spartan-ng/ui-autocomplete-helm';
import { HlmInputDirective } from '@spartan-ng/ui-input-helm';
import { HlmRadioGroupModule } from '@spartan-ng/ui-radiogroup-helm';
import { ColorPickerDirective } from 'ngx-color-picker';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { TreeSelectModule } from 'primeng/treeselect';
import { AlertErrorMessageComponent } from './alert-error-message/alert-error-message.component';
import { AlertMessageComponent } from './alert-message-component/alert-message.component';
import { AlertSuccessMessageComponent } from './alert-success-message/alert-success-message.component';
import { AlertWarningMessageComponent } from './alert-warning-message/alert-warning-message.component';
import { BottomPopupComponent } from './bottom-popup/bottom-popup.component';
import { FinxoneCurrencyAmountInputComponent } from './currency-amount-input/currency-amount-input.component';
import { FinxoneSliderComponent } from './finxone-slider/finxone-slider.component';
import { NumberFormatDirective } from './directive/addcomma.directive';
import { ClickOutsideModule } from './directive/click-outside-directive.module';
import { NumberMaxLengthDirective } from './directive/number-maxlength.directive';
import { SafeHtmlPipe } from './directive/safeHtml.pipe';
import { FinxButtonComponent } from './finx-button/finx-button.component';
import { FinxDatePickerComponent } from './finx-date-picker/finx-date-picker.component';
import { FinxDropdownComponent } from './finx-dropdown/finx-dropdown.component';
import { FinxInputComponent } from './finx-input/finx-input.component';
import { FinxInputMaskComponent } from './finx-inputmask/finx-inputmask.component';
import { FinxLabelComponent } from './finx-label/finx-label.component';
import { FinxSwitchComponent } from './finx-switch/finx-switch.component';
import { FinxTableComponent } from './finx-table/finx-table.component';
import { FinxTagComponent } from './finx-tag/finx-tag.component';
import { FinxoneCheckboxComponent } from './finxone-checkbox/finxone-checkbox.component';
import { FinxoneDatePickerComponent } from './finxone-datepicker/finxone-datepicker.component';
import { FinxoneEmailComponent } from './finxone-email/finxone-email.component';
import { FinxoneInputComponent } from './finxone-input/finxone-input.component';
import { FinxoneMenuComponent } from './finxone-menu/finxone-menu.component';
import { FinxonePhoneNumberComponent } from './finxone-phone-number/finxone-phone-number.component';
import { FinxoneRadioComponent } from './finxone-radio/finxone-radio.component';
import { FinxoneSelectDropdownComponent } from './finxone-select-dropdown/finxone-select-dropdown.component';
import { FinxoneTextAreaComponent } from './finxone-textarea/finxone-textarea.component';
import { ProgressBarComponent } from './progress-bar-module/progress-bar.component';
import { WorkflowFinxInputComponent } from './workflow-finx-input/workflow-finx-input.component';
import { WorkflowFinxoneTableComponent } from './workflow-finxone-table/workflow-finxone-table.component';
import { WorkflowTooltipComponent } from './workflow-finxone-tooltip/workflow-finxone-tooltip.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { WorkflowCardSelectionDialogComponent } from './workflow/card-selection-dialog/card-selection-dialog.component';
import { WorkflowResetWidgetDialogComponent } from './workflow/reset-widget-config-rhs/reset-widget-config-rhs-dialog.component';
import { WorkflowFinxColorpickerComponent } from './workflow/workflow-finx-colorpicker/workflow-finx-colorpicker.component';
import { WorkflowFinxDropdownComponent } from './workflow/workflow-finx-dropdown/workflow-finx-dropdown.component';
import { WorkflowFinxTreeselectComponent } from './workflow/workflow-finx-treeselect/workflow-finx-treeselect.component';
import { BrnSliderImports } from '@spartan-ng/brain/slider';
import { HlmBadge } from '@spartan-ng/helm/badge';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { FinxoneAutocompleteInputComponent } from './finxone-autocomplete-input/finxone-autocomplete-input.component';
import { FinxoneSwitchComponent } from './finxone-switch/finxone-switch.component';
//TODO Split out workflow ui components into their own module
@NgModule({
  declarations: [
    FinxoneInputComponent,
    FinxoneEmailComponent,
    FinxoneDatePickerComponent,
    FinxonePhoneNumberComponent,
    FinxoneTextAreaComponent,
    FinxoneRadioComponent,
    FinxoneCheckboxComponent,
    FinxInputComponent,
    FinxInputMaskComponent,
    FinxLabelComponent,
    FinxButtonComponent,
    FinxDatePickerComponent,
    FinxDropdownComponent,
    WorkflowCardSelectionDialogComponent,
    WorkflowResetWidgetDialogComponent,
    WorkflowFinxInputComponent,
    BottomPopupComponent,
    AlertErrorMessageComponent,
    AlertSuccessMessageComponent,
    FinxSwitchComponent,
    WorkflowFinxTreeselectComponent,
    WorkflowFinxColorpickerComponent,
    ProgressBarComponent,
    FinxTableComponent,
    FinxTagComponent,
    WorkflowFinxoneTableComponent,
    AlertWarningMessageComponent,
    AlertMessageComponent,
    FinxoneCurrencyAmountInputComponent,
    WorkflowTooltipComponent,
    FinxoneSliderComponent,
    FinxoneAutocompleteInputComponent,
    FinxoneSwitchComponent,
  ],
  imports: [
    NumberFormatDirective,
    NumberMaxLengthDirective,
    SafeHtmlPipe,
    RgbaToHexPipe,
    OnBlurValidationDirective,
    TreeSelectModule,
    ProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    // InputMaskModule,
    ColorPickerDirective,
    CommonModule,
    NgxSmartModalModule.forRoot(),
    MatIconModule,
    MultiSelectModule,
    TableModule,
    HlmInputDirective,
    OverlayModule,
    HlmDatePickerModule,
    HlmRadioGroupModule,
    HlmBadge,
    ClickOutsideModule,
    // standalone components
    WorkflowFinxDropdownComponent,
    FinxoneMenuComponent,
    FinxoneSelectDropdownComponent,
    TooltipComponent,
    ...BrnSliderImports,
    HlmAutocompleteModule,
    ...HlmTableImports,
  ],
  providers: [NgxSmartModalService, DecimalPipe, SafeHtmlPipe],
  exports: [
    NumberFormatDirective,
    NumberMaxLengthDirective,
    SafeHtmlPipe,
    RgbaToHexPipe,
    OnBlurValidationDirective,
    FinxoneInputComponent,
    FinxoneEmailComponent,
    FinxoneDatePickerComponent,
    FinxonePhoneNumberComponent,
    FinxoneTextAreaComponent,
    FinxoneRadioComponent,
    FinxoneCheckboxComponent,
    FinxInputComponent,
    FinxInputMaskComponent,
    FinxLabelComponent,
    FinxButtonComponent,
    FinxDatePickerComponent,
    FinxDropdownComponent,
    WorkflowCardSelectionDialogComponent,
    WorkflowResetWidgetDialogComponent,
    WorkflowFinxInputComponent,
    BottomPopupComponent,
    SafeHtmlPipe,
    AlertErrorMessageComponent,
    AlertSuccessMessageComponent,
    FinxSwitchComponent,
    WorkflowFinxTreeselectComponent,
    WorkflowFinxColorpickerComponent,
    ProgressBarComponent,
    FinxTableComponent,
    FinxTagComponent,
    ColorPickerDirective,
    WorkflowFinxoneTableComponent,
    AlertWarningMessageComponent,
    AlertMessageComponent,
    OnBlurValidationDirective,
    HlmInputDirective,
    HlmDatePickerComponent,
    RgbaToHexPipe,
    NumberMaxLengthDirective,
    ClickOutsideModule,
    FinxoneCurrencyAmountInputComponent,
    WorkflowTooltipComponent,
    TooltipComponent,
    FinxoneSliderComponent,
    FinxoneAutocompleteInputComponent,
    FinxoneSwitchComponent,
  ],
})
export class UiComponentsModule {}
